import * as React from 'react';
import {useSelector} from 'react-redux';
import {Button, Stack, Text} from '@treatwell/ui';

import styles from './Error.module.css';
import {selectCmsErrorMessages} from '../../store/models/cms/model';
import {useTranslation} from 'react-i18next';

type Props = {
  labels: {
    header: string;
    description: string;
    button?: string;
  };
  onClick?: () => void;
};

export const Error: React.FC<Props> = ({labels, onClick}: Props) => {
  return (
    <Stack
      space="lg"
      align="center"
      justify="center"
      className={styles.container}
      data-cy="Error-container"
    >
      <Text type="mdHeader" as="h1">
        {labels.header}
      </Text>
      <Text type="body" as="p">
        {labels.description}
      </Text>

      {labels.button && <Button onClick={onClick}>{labels.button}</Button>}
    </Stack>
  );
};

export const GenericError = (): React.ReactElement => {
  let header: string;
  let description: string;
  try {
    const labels = useSelector(selectCmsErrorMessages);
    header = labels.generic.header;
    description = labels.generic.description;
  } catch (err) {
    header = 'There was a problem with this page';
    description = 'Please refresh to try again';
  }
  return (
    <Error
      labels={{
        header,
        description,
      }}
    />
  );
};

export const DirectBookingsError = (): React.ReactElement => {
  const {t} = useTranslation();

  const header = t('directBookings.errorPage.header');
  const description = t('directBookings.errorPage.description');
  const button = t('directBookings.errorPage.button');

  return (
    <Error
      labels={{
        header,
        description,
        button,
      }}
      onClick={() => window.location.assign('/')}
    />
  );
};

GenericError.displayName = 'GenericError';
